export type StatusCode = "200" | "404" | "500";

const BASE_URL = "https://api.eventsquare.io";

interface StatusResponse {
  status: StatusCode;
}

export const getScannedQRCodeStatus = async (
  data: StatusCode
): Promise<StatusResponse> => {
  const response = await fetch(`${BASE_URL}/1.0/statuscode/${data}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`API error ${response.status}: ${text.slice(0, 200)}`);
  }

  const responseData = await response.json();

  if (
    !responseData ||
    typeof responseData !== "object" ||
    !("status" in responseData)
  ) {
    throw new Error("Invalid response format from API");
  }

  return responseData as StatusResponse;
};
